import { API_ROUTES } from '@/api/apiRoutes';



import { EDesktopNavigationLayout } from './enums';
import { PageResponse, PortalBootResponse } from './types';
import { getEnvVariable } from '@/lib/getEnvVariable';

export const fallbackBoot = {
  isFallbackBoot: true,
  portalId: '67e041bc140efa31b2287a1d',
  companyId: 'Rony-Company-Dev',
  portalName: "Princess' Portals",
  portalDomain: 'rony-princess-portal.appchargestore.com',
  stores: ['652e47bbaf70d41b8b009a71'],
  locale: 'en',
  theme: {
    portalLogo:
      'https://media-dev.appcharge.com/media/652e47bbaf70d41b8b009a71/1732032881235__4391a793-d9fa-4155-966f-a2050efbf142',
    portalFavIcon:
      'https://media-dev.appcharge.com/media/652e47bbaf70d41b8b009a71/1735661330358__807a7145-312b-4028-8452-d56c8dfd81ac',
    browserTabName: 'My Portal',
    font: 'Roboto',
    general: {
      sectionTextColor: '#ffffff',
    },
    header: {
      textColor: '#ffffff',
      title: 'Welcome to the new Portal',
      subTitle: 'Play & Win',
      backgroundImage: '',
      showPlayerName: true,
      showPlayerId: false,
      showPlayerBalance: true,
      showTranslations: true,
      backgroundColor: {
        colorOne: '#1a1a1a',
        colorTwo: '#1a1a1a',
        gradientDirection: 'to left',
      },
    },
    menu: {
      textColor: '#f0f0f0',
      backgroundColor: {
        colorOne: '#2a2a2a',
        colorTwo: '',
        gradientDirection: '',
      },
      tabBackgroundColor: {
        colorOne: '#2a2a2a',
        colorTwo: '',
        gradientDirection: '',
      },
      tabHoverColor: {
        colorOne: '#3a3a3a',
        colorTwo: '',
        gradientDirection: '',
      },
      desktopNavigationLayout: EDesktopNavigationLayout.LEFT_SIDEBAR,
    },
    footer: {
      textColor: '#ffffff',
      privacyPolicyUrl: 'https://example.com/privacy',
      termsOfServiceUrl: 'https://example.com/terms',
      supportUrl: 'https://example.com/support',
      backgroundColor: {
        colorOne: '#1a1a1a',
        colorTwo: '',
        gradientDirection: '',
      },
    },
    card: {
      textColor: '#e8e8e8',
      borderWidth: 2,
      borderStyle: 'solid',
      borderRadius: 13,
      backgroundColor: {
        colorOne: '#ffffff',
        colorTwo: '#f5f5f5',
        gradientDirection: 'to bottom',
      },
      borderColor: {
        colorOne: '#808080',
        colorTwo: '#a3a3a3',
        gradientDirection: 'to bottom',
      },
    },
    backgroundColor: {
      colorOne: '#2a2a2a',
      colorTwo: '#2a2a2a',
      gradientDirection: 'to left',
    },
  },
  createdAt: '2025-03-23T17:15:40.507Z',
  updatedAt: '2025-03-23T17:20:35.002Z',
  settings: {
    seo: {
      portalDescription: "Princess' Portals",
      portalUrl: 'rony-princess-portal.appchargestore.com',
      portalKeywords: [],
    },
    addToHomeScreen: {
      active: true,
      title: 'Add to Home Screen',
      description: 'Add this app to your home screen for quick access',
      icon: 'https://example.com/icon.png',
    },
  },
  // A list, because that is what `PortalBootResponse` declares and what every
  // reader does array work on. This was an object, and since the fallback is
  // returned without going through `processBootData` it reached those readers
  // unconverted, taking the render down with it.
  pages: [] as PageResponse[],
};

export function processBootData(bootJson: any): PortalBootResponse {
  const tempBoot = {
    ...bootJson
  } as Partial<PortalBootResponse>;

  const pagesArray = Object.entries(tempBoot.pages || {}).map(([key, page]) => ({
    ...page
  })) as PageResponse[];

  tempBoot.pages = pagesArray;

  return tempBoot as PortalBootResponse;
}

export function getBootApiRoute(domain: string, locale: string): string {
  const baseRoute = `${getEnvVariable('NEXT_PUBLIC_REACT_APP_API_BASE_URL', process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL) || 'https://ext-stg-api.appchargestore.com'}${API_ROUTES.BOOT}/${domain}`;

  return `${baseRoute}?locale=${encodeURIComponent(locale)}`;
}
